import type { PaletteColor } from "@mui/material";
import { useTheme } from "@mui/material";
import { useMemo } from "react";

import type { CustomPaletteKey } from "@citrine/theme";

type DataVizKeys = CustomPaletteKey & `dataViz${number}`;

export const useDataVizColors = () => {
  const theme = useTheme();

  const colors = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(theme.palette).filter(([key]) => /^dataViz/.test(key)),
      ) as Record<DataVizKeys, PaletteColor>,
    [theme.palette],
  );

  return colors;
};

/** Excludes dataViz13 (the grey color palette) */
export const useDataVizColorVariants = () => {
  const dataVizColors = useDataVizColors();

  return useMemo(() => {
    const colorsWithoutGrey = Object.fromEntries(
      Object.entries(dataVizColors).filter(
        ([, palette]) => palette !== dataVizColors.dataViz13,
      ),
    );

    return [
      ...Object.values(colorsWithoutGrey).map(({ main }) => main),
      ...Object.values(colorsWithoutGrey).map(({ dark }) => dark),
      ...Object.values(colorsWithoutGrey).map(({ light }) => light),
    ];
  }, [dataVizColors]);
};
